export default "__VITE_ASSET__3I9WdNWh__"